<div class="cb-notification-popover">
  @if (isLoading()) {
    <cb-loader></cb-loader>
  } @else {
    <div class="cb-notification-popover-header">
      <p>
        {{ "NOTIFICATIONS.POPOVER.TITLE" | translate }}
      </p>
      <cb-button
        type="default"
        size="xs"
        hierarchy="secondary"
        color="brand"
        [label]="'NOTIFICATIONS.CENTER.OPEN_BUTTON' | translate"
        icon="cb-base-outline-inbox"
        (click)="openNotificationCenter()"
      ></cb-button>
    </div>

    @for (notification of notifications(); track $index) {
      <div
        class="cb-notification-popover-item"
        [ngClass]="'cb-color-' + notification.type"
        [class.cb-clickable]="notification.palletId"
        (click)="openPalletDialog(notification.palletId)"
      >
        <div class="cb-notification-popover-item-icon">
          <cb-icon [name]="notification.icon"></cb-icon>
        </div>
        <div class="cb-notification-popover-item-content">
          <div class="cb-notification-popover-item-content-header">
            <h6>
              {{ notification.title | translate }}

              @if (notification.palletUdc) {
                <span>
                  {{ notification.palletUdc }}
                </span>
              } @else {
                @if (getSubjectName(notification.data); as subjectName) {
                  <span>
                    {{ subjectName }}
                  </span>
                }
              }
            </h6>

            @if (getStaffMemberName(notification.data); as staffMemberName) {
              <cb-avatar
                [label]="staffMemberName"
                type="initials"
                size="xs"
              ></cb-avatar>
            }
          </div>

          <!-- Show notification time -->
          <div class="cb-notification-popover-item-time">
            <cb-icon name="cb-base-outline-clock" size="xs"></cb-icon>
            <span>{{ notification.startDate | date: "dd/MM/yyyy HH:mm" }}</span>
          </div>

          @if (notification.message) {
            <p class="cb-notification-popover-item-message">
              {{ notification.message }}
            </p>
          }

          <!-- Show pallet info if available -->
          @if (notification.palletId) {
            <div class="cb-notification-popover-item-pallet-info">
              @if (notification.palletCompanyName) {
                <cb-chip
                  type="minimal"
                  color="gray"
                  iconPosition="left"
                  icon="cb-app-bold-building-03"
                  iconType="icon"
                  [label]="notification.palletCompanyName"
                ></cb-chip>
              }
              @if (notification.palletPackagesCount) {
                <cb-chip
                  type="minimal"
                  color="gray"
                  iconPosition="left"
                  icon="cb-app-bold-package-02"
                  iconType="icon"
                  [label]="
                    'COMMON.PACKAGES'
                      | translate: { count: notification.palletPackagesCount }
                  "
                ></cb-chip>
              }
              @if (notification.palletStatus) {
                <cb-pallet-status-chip
                  [value]="notification.palletStatus"
                ></cb-pallet-status-chip>
              }
            </div>
          }
        </div>

        <!-- Arrow icon to open pallet dialog -->
        @if (notification.palletId) {
          <cb-icon
            class="cb-notification-popover-item-action"
            name="cb-stroke-rounded-arrow-up-right-01"
          ></cb-icon>
        }

        <!-- Button to open the linked outgoing order dialog -->
        @if (notification.outgoingOrderId) {
          <cb-button
            type="iconOnly"
            size="xs"
            hierarchy="secondary"
            color="brand"
            icon="cb-stroke-rounded-arrow-up-right-01"
            (click)="openOutgoingOrderDialog(notification.outgoingOrderId)"
          ></cb-button>
        }

        <cb-button
          type="iconOnly"
          size="xs"
          hierarchy="secondary"
          color="success"
          icon="cb-stroke-rounded-tick-01"
          (click)="readNotification(notification.data.id)"
        ></cb-button>
      </div>
    } @empty {
      <cb-empty-state
        [subtitle]="'NOTIFICATIONS.EMPTY.SUBTITLE' | translate"
      ></cb-empty-state>
    }
  }
</div>
